const country = [
	{
		"name": "SINGAPORE",
		"value": "SG",
		"cc": "+65" 
	},
	{
		"name": "AFGHANISTAN",
		"value": "AF",
		"cc": "+93" 
	},
	{
		"name": "ALAND ISLANDS",
		"value": "AX",
		"cc": "+358" 
	},
	{
		"name": "ALBANIA",
		"value": "AL",
		"cc": "+355" 
	},
	{
		"name": "ALGERIA",
		"value": "DZ",
		"cc": "+213" 
	},
	{
		"name": "AMERICAN SAMOA",
		"value": "AS",
		"cc": "+1-684" 
	},
	{
		"name": "ANDORRA",
		"value": "AD",
		"cc": "+376" 
	},
	{
		"name": "ANGOLA",
		"value": "AO",
		"cc": "+244" 
	},
	{
		"name": "ANGUILLA",
		"value": "AI",
		"cc": "+1-264" 
	},
	{
		"name": "ANTARCTICA",
		"value": "AQ",
		"cc": "+672" 
	},
	{
		"name": "ANTIGUA AND BARBUDA",
		"value": "AG",
		"cc": "+1-268" 
	},
	{
		"name": "ARGENTINA",
		"value": "AR",
		"cc": "+54" 
	},
	{
		"name": "ARMENIA",
		"value": "AM",
		"cc": "+374" 
	},
	{
		"name": "ARUBA",
		"value": "AW",
		"cc": "+297" 
	},
	{
		"name": "AUSTRALIA",
		"value": "AU",
		"cc": "+61" 
	},
	{
		"name": "AUSTRIA",
		"value": "AT",
		"cc": "+43" 
	},
	{
		"name": "AZERBAIJAN",
		"value": "AZ",
		"cc": "+994" 
	},
	{
		"name": "BAHAMAS",
		"value": "BS",
		"cc": "+1-242" 
	},
	{
		"name": "BAHRAIN",
		"value": "BH",
		"cc": "+973" 
	},
	{
		"name": "BANGLADESH",
		"value": "BD",
		"cc": "+880" 
	},
	{
		"name": "BARBADOS",
		"value": "BB",
		"cc": "+1-246" 
	},
	{
		"name": "BELARUS",
		"value": "BY",
		"cc": "+375" 
	},
	{
		"name": "BELGIUM",
		"value": "BE",
		"cc": "+32" 
	},
	{
		"name": "BELIZE",
		"value": "BZ",
		"cc": "+501" 
	},
	{
		"name": "BENIN",
		"value": "BJ",
		"cc": "+229" 
	},
	{
		"name": "BERMUDA",
		"value": "BM",
		"cc": "+1-441" 
	},
	{
		"name": "BHUTAN",
		"value": "BT",
		"cc": "+975" 
	},
	{
		"name": "BOLIVIA, PLURINATIONAL STATE OF",
		"value": "BO",
		"cc": "+591" 
	},
	{
		"name": "BONAIRE SINT EUSTATIUS AND SABA",
		"value": "BQ",
		"cc": "+599" 
	},
	{
		"name": "BOSNIA AND HERZEGOVINA",
		"value": "BA",
		"cc": "+387" 
	},
	{
		"name": "BOTSWANA",
		"value": "BW",
		"cc": "+267" 
	},
	{
		"name": "BOUVET ISLAND",
		"value": "BV",
		"cc": "+47" 
	},
	{
		"name": "BRAZIL",
		"value": "BR",
		"cc": "+55" 
	},
	{
		"name": "BRITISH INDIAN OCEAN TERRITORY",
		"value": "IO",
		"cc": "+246" 
	},
	{
		"name": "BRUNEI DARUSSALAM",
		"value": "BN",
		"cc": "+673" 
	},
	{
		"name": "BULGARIA",
		"value": "BG",
		"cc": "+359" 
	},
	{
		"name": "BURKINA FASO",
		"value": "BF",
		"cc": "+226" 
	},
	{
		"name": "BURUNDI",
		"value": "BI",
		"cc": "+257" 
	},
	{
		"name": "CAMBODIA",
		"value": "KH",
		"cc": "+855" 
	},
	{
		"name": "CAMEROON",
		"value": "CM",
		"cc": "+237" 
	},
	{
		"name": "CANADA",
		"value": "CA",
		"cc": "+1" 
	},
	{
		"name": "CAPE VERDE",
		"value": "CV",
		"cc": "+238" 
	},
	{
		"name": "CAYMAN ISLANDS",
		"value": "KY",
		"cc": "+1-345" 
	},
	{
		"name": "CENTRAL AFRICAN REPUBLIC",
		"value": "CF",
		"cc": "+236" 
	},
	{
		"name": "CHAD",
		"value": "TD",
		"cc": "+235" 
	},
	{
		"name": "CHILE",
		"value": "CL",
		"cc": "+56" 
	},
	{
		"name": "CHINA",
		"value": "CN",
		"cc": "+86" 
	},
	{
		"name": "CHRISTMAS ISLAND",
		"value": "CX",
		"cc": "+61" 
	},
	{
		"name": "COCOS (KEELING) ISLANDS",
		"value": "CC",
		"cc": "+61" 
	},
	{
		"name": "COLOMBIA",
		"value": "CO",
		"cc": "+57" 
	},
	{
		"name": "COMOROS",
		"value": "KM",
		"cc": "+269" 
	},
	{
		"name": "CONGO",
		"value": "CG",
		"cc": "+242" 
	},
	{
		"name": "CONGO, THE DEMOCRATIC REPUBLIC OF THE",
		"value": "CD",
		"cc": "+243" 
	},
	{
		"name": "COOK ISLANDS",
		"value": "CK",
		"cc": "+682" 
	},
	{
		"name": "COSTA RICA",
		"value": "CR",
		"cc": "+506" 
	},
	{
		"name": "COTE D'IVOIRE",
		"value": "CI",
		"cc": "+225" 
	},
	{
		"name": "CROATIA",
		"value": "HR",
		"cc": "+385" 
	},
	{
		"name": "CUBA",
		"value": "CU",
		"cc": "+53" 
	},
	{
		"name": "CURACAO",
		"value": "CW",
		"cc": "+599" 
	},
	{
		"name": "CYPRUS",
		"value": "CY",
		"cc": "+357" 
	},
	{
		"name": "CZECH REPUBLIC",
		"value": "CZ",
		"cc": "+420" 
	},
	{
		"name": "DENMARK",
		"value": "DK",
		"cc": "+45"
	},
	{
		"name": "DJIBOUTI",
		"value": "DJ",
		"cc": "+253"
	},
	{
		"name": "DOMINICA",
		"value": "DM",
		"cc": "+1-767"
	},
	{
		"name": "DOMINICAN REPUBLIC",
		"value": "DO",
		"cc": "+1-809"
	},
	{
		"name": "ECUADOR",
		"value": "EC",
		"cc": "+593"
	},
	{
		"name": "EGYPT",
		"value": "EG",
		"cc": "+20"
	},
	{
		"name": "EL SALVADOR",
		"value": "SV",
		"cc": "+503"
	},
	{
		"name": "EQUATORIAL GUINEA",
		"value": "GQ",
		"cc": "+240"
	},
	{
		"name": "ERITREA",
		"value": "ER",
		"cc": "+291"
	},
	{
		"name": "ESTONIA",
		"value": "EE",
		"cc": "+372"
	},
	{
		"name": "ETHIOPIA",
		"value": "ET",
		"cc": "+251"
	},
	{
		"name": "FALKLAND ISLANDS (MALVINAS)",
		"value": "FK",
		"cc": "+500"
	},
	{
		"name": "FAROE ISLANDS",
		"value": "FO",
		"cc": "+298"
	},
	{
		"name": "FIJI",
		"value": "FJ",
		"cc": "+679"
	},
	{
		"name": "FINLAND",
		"value": "FI",
		"cc": "+358"
	},
	{
		"name": "FRANCE",
		"value": "FR",
		"cc": "+33"
	},
	{
		"name": "FRENCH GUIANA",
		"value": "GF",
		"cc": "+594"
	},
	{
		"name": "FRENCH POLYNESIA",
		"value": "PF",
		"cc": "+689"
	},
	{
		"name": "FRENCH SOUTHERN TERRITORIES",
		"value": "TF",
		"cc": "+262"
	},
	{
		"name": "GABON",
		"value": "GA",
		"cc": "+241"
	},
	{
		"name": "GAMBIA",
		"value": "GM",
		"cc": "+220"
	},
	{
		"name": "GEORGIA",
		"value": "GE",
		"cc": "+995"
	},
	{
		"name": "GERMANY",
		"value": "DE",
		"cc": "+49"
	},
	{
		"name": "GHANA",
		"value": "GH",
		"cc": "+233"
	},
	{
		"name": "GIBRALTAR",
		"value": "GI",
		"cc": "+350"
	},
	{
		"name": "GREECE",
		"value": "GR",
		"cc": "+30"
	},
	{
		"name": "GREENLAND",
		"value": "GL",
		"cc": "+299"
	},
	{
		"name": "GRENADA",
		"value": "GD",
		"cc": "+1-473"
	},
	{
		"name": "GUADELOUPE",
		"value": "GP",
		"cc": "+590"
	},
	{
		"name": "GUAM",
		"value": "GU",
		"cc": "+1-671"
	},
	{
		"name": "GUATEMALA",
		"value": "GT",
		"cc": "+502"
	},
	{
		"name": "GUERNSEY",
		"value": "GG",
		"cc": "+44-1481"
	},
	{
		"name": "GUINEA",
		"value": "GN",
		"cc": "+224"
	},
	{
		"name": "GUINEA-BISSAU",
		"value": "GW",
		"cc": "+245"
	},
	{
		"name": "GUYANA",
		"value": "GY",
		"cc": "+592"
	},
	{
		"name": "HAITI",
		"value": "HT",
		"cc": "+509"
	},
	{
		"name": "HEARD ISLAND AND MCDONALD ISLANDS",
		"value": "HM",
		"cc": "+672"
	},
	{
		"name": "HOLY SEE (VATICAN CITY STATE)",
		"value": "VA",
		"cc": "+379"
	},
	{
		"name": "HONDURAS",
		"value": "HN",
		"cc": "+504"
	},
	{
		"name": "HONG KONG",
		"value": "HK",
		"cc": "+852"
	},
	{
		"name": "HUNGARY",
		"value": "HU",
		"cc": "+36"
	},
	{
		"name": "ICELAND",
		"value": "IS",
		"cc": "+354"
	},
	{
		"name": "INDIA",
		"value": "IN",
		"cc": "+91"
	},
	{
		"name": "INDONESIA",
		"value": "ID",
		"cc": "+62"
	},
	{
		"name": "IRAN ISLAMIC REPUBLIC OF",
		"value": "IR",
		"cc": "+98"
	},
	{
		"name": "IRAQ",
		"value": "IQ",
		"cc": "+964"
	},
	{
		"name": "IRELAND",
		"value": "IE",
		"cc": "+353"
	},
	{
		"name": "ISLE OF MAN",
		"value": "IM",
		"cc": "+44-1624"
	},
	{
		"name": "ISRAEL",
		"value": "IL",
		"cc": "+972"
	},
	{
		"name": "ITALY",
		"value": "IT",
		"cc": "+39"
	},
	{
		"name": "JAMAICA",
		"value": "JM",
		"cc": "+1-876"
	},
	{
		"name": "JAPAN",
		"value": "JP",
		"cc": "+81"
	},
	{
		"name": "JERSEY",
		"value": "JE",
		"cc": "+44-1534"
	},
	{
		"name": "JORDAN",
		"value": "JO",
		"cc": "+962"
	},
	{
		"name": "KAZAKHSTAN",
		"value": "KZ",
		"cc": "+7"
	},
	{
		"name": "KENYA",
		"value": "KE",
		"cc": "+254"
	},
	{
		"name": "KIRIBATI",
		"value": "KI",
		"cc": "+686"
	},
	{
		"name": "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF",
		"value": "KP",
		"cc": "+850"
	},
	{
		"name": "KOREA, REPUBLIC OF",
		"value": "KR",
		"cc": "+82"
	},
	{
		"name": "KUWAIT",
		"value": "KW",
		"cc": "+965"
	},
	{
		"name": "KYRGYZSTAN",
		"value": "KG",
		"cc": "+996"
	},
	{
		"name": "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
		"value": "LA",
		"cc": "+856"
	},
	{
		"name": "LATVIA",
		"value": "LV",
		"cc": "+371"
	},
	{
		"name": "LEBANON,",
		"value": "LB",
		"cc": "+961"
	},
	{
		"name": "LESOTHO",
		"value": "LS",
		"cc": "+266"
	},
	{
		"name": "LIBERIA",
		"value": "LR",
		"cc": "+231"
	},
	{
		"name": "LIBYA",
		"value": "LY",
		"cc": "+218"
	},
	{
		"name": "LIECHTENSTEIN",
		"value": "LI",
		"cc": "+423"
	},
	{
		"name": "LITHUANIA",
		"value": "LT",
		"cc": "+370"
	},
	{
		"name": "LUXEMBOURG",
		"value": "LU",
		"cc": "+352"
	},
	{
		"name": "MACAO",
		"value": "MO",
		"cc": "+853"
	},
	{
		"name": "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF",
		"value": "MK",
		"cc": "+389"
	},
	{
		"name": "MADAGASCAR",
		"value": "MG",
		"cc": "+261"
	},
	{
		"name": "MALAWI",
		"value": "MW",
		"cc": "+265"
	},
	{
		"name": "MALAYSIA",
		"value": "MY",
		"cc": "+60"
	},
	{
		"name": "MALDIVES",
		"value": "MV",
		"cc": "+960"
	},
	{
		"name": "MALI",
		"value": "ML",
		"cc": "+223"
	},
	{
		"name": "MALTA",
		"value": "MT",
		"cc": "+356"
	},
	{
		"name": "MARSHALL ISLANDS",
		"value": "MH",
		"cc": "+692"
	},
	{
		"name": "MARTINIQUE",
		"value": "MQ",
		"cc": "+596"
	},
	{
		"name": "MAURITANIA",
		"value": "MR",
		"cc": "+222"
	},
	{
		"name": "MAURITIUS",
		"value": "MU",
		"cc": "+230"
	},
	{
		"name": "MAYOTTE",
		"value": "YT",
		"cc": "+262"
	},
	{
		"name": "MEXICO",
		"value": "MX",
		"cc": "+52"
	},
	{
		"name": "MICRONESIA, FEDERATED STATES OF",
		"value": "FM",
		"cc": "+691"
	},
	{
		"name": "MOLDOVA REPUBLIC OF",
		"value": "MD",
		"cc": "+373"
	},
	{
		"name": "MONACO",
		"value": "MC",
		"cc": "+377"
	},
	{
		"name": "MONGOLIA",
		"value": "MN",
		"cc": "+976"
	},
	{
		"name": "MONTENEGRO",
		"value": "ME",
		"cc": "+382"
	},
	{
		"name": "MONTSERRAT",
		"value": "MS",
		"cc": "+1-664"
	},
	{
		"name": "MOROCCO",
		"value": "MA",
		"cc": "+212"
	},
	{
		"name": "MOZAMBIQUE",
		"value": "MZ",
		"cc": "+258"
	},
	{
		"name": "MYANMAR",
		"value": "MM",
		"cc": "+95"
	},
	{
		"name": "NAMIBIA",
		"value": "NA",
		"cc": "+264"
	},
	{
		"name": "NAURU",
		"value": "NR",
		"cc": "+674"
	},
	{
		"name": "NEPAL",
		"value": "NP",
		"cc": "+977"
	},
	{
		"name": "NETHERLANDS",
		"value": "NL",
		"cc": "+31"
	},
	{
		"name": "NETHERLANDS ANTILLES",
		"value": "AN",
		"cc": "+599"
	},
	{
		"name": "NEW CALEDONIA",
		"value": "NC",
		"cc": "+687"
	},
	{
		"name": "NEW ZEALAND",
		"value": "NZ",
		"cc": "+64"
	},
	{
		"name": "NICARAGUA",
		"value": "NI",
		"cc": "+505"
	},
	{
		"name": "NIGER",
		"value": "NE",
		"cc": "+227"
	},
	{
		"name": "NIGERIA",
		"value": "NG",
		"cc": "+234"
	},
	{
		"name": "NIUE",
		"value": "NU",
		"cc": "+683"
	},
	{
		"name": "NORFOLK ISLAND",
		"value": "NF",
		"cc": "+672"
	},
	{
		"name": "NORTHERN MARIANA ISLANDS",
		"value": "MP",
		"cc": "+1-670"
	},
	{
		"name": "NORWAY",
		"value": "NO",
		"cc": "+47"
	},
	{
		"name": "OMAN",
		"value": "OM",
		"cc": "+968"
	},
	{
		"name": "OTHERS",
		"value": "OT",
		"cc": ""
	},
	{
		"name": "PAKISTAN",
		"value": "PK",
		"cc": "+92"
	},
	{
		"name": "PALAU",
		"value": "PW",
		"cc": "+680"
	},
	{
		"name": "PALESTINIAN TERRITORY, OCCUPIED",
		"value": "PS",
		"cc": "+970"
	},
	{
		"name": "PANAMA",
		"value": "PA",
		"cc": "+507"
	},
	{
		"name": "PAPUA NEW GUINEA",
		"value": "PG",
		"cc": "+675"
	},
	{
		"name": "PARAGUAY",
		"value": "PY",
		"cc": "+595"
	},
	{
		"name": "PERU",
		"value": "PE",
		"cc": "+51"
	},
	{
		"name": "PHILIPPINES",
		"value": "PH",
		"cc": "+63"
	},
	{
		"name": "PITCAIRN",
		"value": "PN",
		"cc": "+64"
	},
	{
		"name": "POLAND",
		"value": "PL",
		"cc": "+48"
	},
	{
		"name": "PORTUGAL",
		"value": "PT",
		"cc": "+351"
	},
	{
		"name": "PUERTO RICO",
		"value": "PR",
		"cc": "+1"
	},
	{
		"name": "QATAR",
		"value": "QA",
		"cc": "+974"
	},
	{
		"name": "REUNION",
		"value": "RE",
		"cc": "+262"
	},
	{
		"name": "ROMANIA",
		"value": "RO",
		"cc": "+40"
	},
	{
		"name": "RUSSIAN FEDERATION",
		"value": "RU",
		"cc": "+7"
	},
	{
		"name": "RWANDA",
		"value": "RW",
		"cc": "+250"
	},
	{
		"name": "SAINT BARTHELEMY",
		"value": "BL",
		"cc": "+590"
	},
	{
		"name": "SAINT HELENA ASCENSION AND TRISTAN DA CUNHA",
		"value": "SH",
		"cc": "+290"
	},
	{
		"name": "SAINT KITTS AND NEVIS",
		"value": "KN",
		"cc": "+1-869"
	},
	{
		"name": "SAINT LUCIA",
		"value": "LC",
		"cc": "+1-758"
	},
	{
		"name": "SAINT MARTIN (FRENCH PART)",
		"value": "MF",
		"cc": "+590"
	},
	{
		"name": "SAINT PIERRE AND MIQUELON",
		"value": "PM",
		"cc": "+508"
	},
	{
		"name": "SAINT VINCENT AND THE GRENADINES",
		"value": "VC",
		"cc": "+1-784"
	},
	{
		"name": "SAMOA",
		"value": "WS",
		"cc": "+685"
	},
	{
		"name": "SAN MARINO",
		"value": "SM",
		"cc": "+378"
	},
	{
		"name": "SAO TOME AND PRINCIPE",
		"value": "ST",
		"cc": "+239"
	},
	{
		"name": "SAUDI ARABIA",
		"value": "SA",
		"cc": "+966"
	},
	{
		"name": "SENEGAL",
		"value": "SN",
		"cc": "+221"
	},
	{
		"name": "SERBIA",
		"value": "RS",
		"cc": "+381"
	},
	{
		"name": "SERBIA AND MONTENEGRO",
		"value": "CS",
		"cc": "+381"
	},
	{
		"name": "SEYCHELLES",
		"value": "SC",
		"cc": "+248"
	},
	{
		"name": "SIERRA LEONE",
		"value": "SL",
		"cc": "+232"
	},
	{
		"name": "SINT MAARTEN (DUTCH PART)",
		"value": "SX",
		"cc": "+1-721"
	},
	{
		"name": "SLOVAKIA",
		"value": "SK",
		"cc": "+421"
	},
	{
		"name": "SLOVENIA",
		"value": "SI",
		"cc": "+386"
	},
	{
		"name": "SOLOMON ISLANDS",
		"value": "SB",
		"cc": "+677"
	},
	{
		"name": "SOMALIA",
		"value": "SO",
		"cc": "+252"
	},
	{
		"name": "SOUTH AFRICA",
		"value": "ZA",
		"cc": "+27"
	},
	{
		"name": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
		"value": "GS",
		"cc": "+500"
	},
	{
		"name": "SOUTH SUDAN",
		"value": "SS",
		"cc": "+211"
	},
	{
		"name": "SPAIN",
		"value": "ES",
		"cc": "+34"
	},
	{
		"name": "SRI LANKA",
		"value": "LK",
		"cc": "+94"
	},
	{
		"name": "SUDAN",
		"value": "SD",
		"cc": "+249"
	},
	{
		"name": "SURINAME",
		"value": "SR",
		"cc": "+597"
	},
	{
		"name": "SVALBARD AND JAN MAYEN",
		"value": "SJ",
		"cc": "+47"
	},
	{
		"name": "SWAZILAND",
		"value": "SZ",
		"cc": "+268"
	},
	{
		"name": "SWEDEN",
		"value": "SE",
		"cc": "+46"
	},
	{
		"name": "SWITZERLAND",
		"value": "CH",
		"cc": "+41"
	},
	{
		"name": "SYRIAN ARAB REPUBLIC",
		"value": "SY",
		"cc": "+963"
	},
	{
		"name": "TAIWAN",
		"value": "TW",
		"cc": "+886"
	},
	{
		"name": "TAJIKISTAN",
		"value": "TJ",
		"cc": "+992"
	},
	{
		"name": "TANZANIA UNITED REPUBLIC OF",
		"value": "TZ",
		"cc": "+255"
	},
	{
		"name": "THAILAND",
		"value": "TH",
		"cc": "+66"
	},
	{
		"name": "TIMOR-LESTE",
		"value": "TL",
		"cc": "+670"
	},
	{
		"name": "TOGO",
		"value": "TG",
		"cc": "+228"
	},
	{
		"name": "TOKELAU",
		"value": "TK",
		"cc": "+690"
	},
	{
		"name": "TONGA",
		"value": "TO",
		"cc": "+676"
	},
	{
		"name": "TRINIDAD AND TOBAGO",
		"value": "TT",
		"cc": "+1-868"
	},
	{
		"name": "TUNISIA",
		"value": "TN",
		"cc": "+216"
	},
	{
		"name": "TURKEY",
		"value": "TR",
		"cc": "+90"
	},
	{
		"name": "TURKMENISTAN",
		"value": "TM",
		"cc": "+993"
	},
	{
		"name": "TURKS AND CAICOS ISLANDS",
		"value": "TC",
		"cc": "+1-649"
	},
	{
		"name": "TUVALU",
		"value": "TV",
		"cc": "+688"
	},
	{
		"name": "UGANDA",
		"value": "UG",
		"cc": "+256"
	},
	{
		"name": "UKRAINE",
		"value": "UA",
		"cc": "+380"
	},
	{
		"name": "UNITED ARAB EMIRATES",
		"value": "AE",
		"cc": "+971"
	},
	{
		"name": "UNITED KINGDOM",
		"value": "GB",
		"cc": "+44"
	},
	{
		"name": "UNITED STATES",
		"value": "US",
		"cc": "+1"
	},
	{
		"name": "UNITED STATES MINOR OUTLYING ISLANDS",
		"value": "UM",
		"cc": "+1"
	},
	{
		"name": "URUGUAY",
		"value": "UY",
		"cc": "+598"
	},
	{
		"name": "UZBEKISTAN",
		"value": "UZ",
		"cc": "+998"
	},
	{
		"name": "VANUATU",
		"value": "VU",
		"cc": "+678"
	},
	{
		"name": "VENEZUELA BOLIVARIAN REPUBLIC OF",
		"value": "VE",
		"cc": "+58"
	},
	{
		"name": "VIET NAM",
		"value": "VN",
		"cc": "+84"
	},
	{
		"name": "VIRGIN ISLANDS, BRITISH",
		"value": "VG",
		"cc": "+1-284"
	},
	{
		"name": "VIRGIN ISLANDS, U.S.",
		"value": "VI",
		"cc": "+1-340"
	},
	{
		"name": "WALLIS AND FUTUNA",
		"value": "WF",
		"cc": "+681"
	},
	{
		"name": "WESTERN SAHARA",
		"value": "EH",
		"cc": "+212"
	},
	{
		"name": "YEMEN",
		"value": "YE",
		"cc": "+967"
	},
	{
		"name": "ZAMBIA",
		"value": "ZM",
		"cc": "+260"
	},
	{
		"name": "ZIMBABWE",
		"value": "ZW",
		"cc": "+263"
	}
]

export default country;
